var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-field',{attrs:{"attribute":_vm.attribute,"type":"textarea","label":_vm.label,"required":_vm.required,"errorKeys":_vm.errorKeys}},[_c('textarea',{domProps:{"textContent":_vm._s(_vm.value)},on:{"input":_vm.update}})])}
var staticRenderFns = []

export { render, staticRenderFns }